
































































































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component } from "vue-property-decorator";
import { $api } from "@/services/ApiService";
import { Certificate, Permission } from "bancojs";
import { $auth } from "@/services/AuthenticationService";
import { saveAs } from "file-saver";
import AgPermissionTable from "@/components/AgPermissionTable.vue";

@Component({
  components: {
    AgPermissionTable,
  },
})
export default class MyCertificatesEdit extends Vue {
  async created() {
    if (this.$route.params.fingerprint) {
      try {
        const res = await $api.client.user.certificates
          .get(this.$route.params.fingerprint)
          .toPromise();
        this.form.data = res;
      } catch (err) {
        console.log(err);
      }
    }
    this.form.loading = false;
  }

  async saveCertificate() {
    try {
      this.form.saving = true;
      await $api.client.user.certificates
        .update(this.form.data.fingerprint, this.form.data)
        .toPromise();
      this.form.saving = false;
      this.$router.push("/my/certificates");
    } catch (err) {
      console.log(err);
      this.form.saving = false;
    }
  }

  get isAdmin() {
    return $auth.hasAnyAdmin();
  }

  get validAfter() {
    return new Date(this.form.data.valid_after).toLocaleString();
  }

  get validBefore() {
    return new Date(this.form.data.valid_before).toLocaleString();
  }

  downloadPEM() {
    const data = new Blob([this.form.data.pem], {
      type: "text/plain;charset=utf-8",
    });
    saveAs(data, "certificado.pem");
  }

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
  };

  form: {
    data: Certificate;
    loading: boolean;
    saving: boolean;
    validForm: boolean;
    tab: number | null;
  } = {
    data: {
      fingerprint: "",
      state: "ACTIVE",
      user_id: "",
      key_id: NaN,
      csr_id: NaN,
      pem: "",
      valid_after: "",
      valid_before: "",
    },
    loading: true,
    saving: false,
    validForm: false,
    tab: null,
  };
}
